module.exports = __webpack_public_path__ + "static/bkg-intro-f5f1e8c3e63cfae82346df6e6ea34524.jpg";